// Constants for retrieving orders
export const RETRIEVE_ORDERS_REQUEST = 'RETRIEVE_ORDERS_REQUEST';
export const RETRIEVE_ORDERS_SUCCESS = 'RETRIEVE_ORDERS_SUCCESS';
export const RETRIEVE_ORDERS_FAIL = 'RETRIEVE_ORDERS_FAIL';
